import UnRoutedPrescriptionsNotificationsContainer from './unrouted-prescriptions-notifications-container';

export default UnRoutedPrescriptionsNotificationsContainer;
